import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { CommerceService } from "@/services/commerce"

import { internalCustomerException } from "../../customer/utils/customerQueryHelpers"
import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { findCustomerTargetAddress } from "../utils/customerAddressInformation"

export const mutationRemoveDefaultShippingAddress = {
  async removeDefaultShippingAddress(parent, args, context, info) {
    const { customerId, customerKey, customerNumber, addressId } = args
    const commerceApi = CommerceService.api()
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.UPDATE,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })
    await internalCustomerException({ id: customer.id })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const targetAddress = findCustomerTargetAddress(customer, addressId)

    if (!targetAddress) return null

    // nothing to do, not a shipping address
    if (!targetAddress.isDefaultShipping || !targetAddress.isShippingAddress) return targetAddress

    // first remove address from shipping address list, this will also remove the default shipping address status
    // then add it back to shipping address list
    const payload = {
      version: customer.version,
      actions: [
        {
          action: "removeShippingAddressId",
          addressId: targetAddress.id,
        },
        {
          action: "addShippingAddressId",
          addressId: targetAddress.id,
        },
      ],
    }

    try {
      const updatedCustomer = (
        await commerceApi
          .customers()
          .withId({ ID: customer.id })
          .post({
            body: JSON.stringify(payload),
          })
          .execute()
      )?.body

      const updatedTargetAddress = findCustomerTargetAddress(updatedCustomer, addressId)

      return updatedTargetAddress
    } catch (e) {
      throw new Error(e)
    }
  },
}
